import { apiUrl, apiUrlV2 } from "../constants/apiUrl"
import rollbarLogger from "../utilities/rollbarLogger"

const initialState = {
  displayCoupons: true,
  couponInfoPageId: null,
  isFetchingCoupons: false,
  isFetchingCoupon: false,
  coupons: [],
  coupon: null,
  couponRedemptions: [],
  isCreatingCouponRedemption: false,
  isFetchingRedeemedCoupons: false,
  currentSlide: 1,
}

const createCouponsSlice = (set, get) => ({
  ...initialState,
  setDisplayCoupons: (boolean) => {
    set((state) => ({displayCoupons: boolean}))
  },
  setCurrentSlide: (slide) => set({ currentSlide: slide }),
  fetchCoupons: async () => {
    set(() => ({ isFetchingCoupons: true }))
    try {
      const response = await fetch(
        `${apiUrlV2}/coupons`,
        { headers: get().requestHeaders }
      )
      if (response.status === 200) {
        const data = await response.json()

        set(() => ({ coupons: data.data }))
      }
    } catch (err) {
      get().logError('There was an error fetching coupons', err)
    } finally {
      set(() => ({ isFetchingCoupons: false }))
    }
  },
  fetchCoupon: async (couponId) => {
    set(() => ({ isFetchingCoupon: true }))
    try {
      const response = await fetch(
        `${apiUrlV2}/coupons/${couponId}`,
        { headers: get().requestHeaders }
      )
      if (response.status === 200) {
        const data = await response.json()

        set(() => ({ coupon: data.data }))
      }
    } catch (err) {
      get().logError('There was an error fetching a coupon.', err)
    } finally {
      set(() => ({ isFetchingCoupon: false }))
    }
  },
  createCouponRedemption: async (couponId, dealerId, optedIn) => {
    set(() => ({ isCreatingCouponRedemption: true }))

    set((state) => ({
      coupons: state.coupons.filter(coupon => coupon.id !== couponId)
    }))

    try {
      const response = await fetch(
        `${apiUrlV2}/coupon_redemptions`,
        {
          headers: get().requestHeaders,
          method: 'POST',
          body: JSON.stringify({dealer_id: dealerId, coupon_id: couponId, opted_in: optedIn})
         }
      )
      if (response.status === 200) {
        const data = await response.json()

        const successMessage = optedIn ?
          data.data.attributes['opt-in-confirmation-message'] || 'Successfully opted in'
        :
          data.data.attributes['opt-out-confirmation-message'] || 'Successfully opted out'
        get().setSuccessMessage(successMessage)
      }
    } catch (err) {
      get().logError('There was an error opting in or out of the coupon.', err)
    } finally {
      set(() => ({ isCreatingCouponRedemption: false }))
    }
  },
  fetchCouponRedemptions: async () => {
    set(() => ({ isFetchingRedeemedCoupons: true }))
    try {
      const response = await fetch(
        `${apiUrlV2}/coupon_redemptions`,
        { headers: get().requestHeaders }
      )
      if (response.status === 200) {
        const data = await response.json()
        set(() => ({ couponRedemptions: data.data}))
      }
    } catch (err) {
      get().logError('Unable to fetch redeemed coupons', err)
    } finally {
      set(() => ({ isFetchingRedeemedCoupons: false }))
    }
  },
  setCouponInfoPageId: (id) => set(() => ({ couponInfoPageId: id })),
  resetCouponsSlice: () => set(initialState)
})

export default createCouponsSlice